import React from 'react';
import { signInWithGoogle, getCurrentUser } from '../services/firebase';
import Button from 'react-bootstrap/Button';
import { PersonCircle, BoxArrowInRight } from 'react-bootstrap-icons';

export function AuthButton() {
  const user = getCurrentUser();
  return user
    ? <div className="d-flex align-items-center"><PersonCircle className="me-2" /> Bienvenido, {user.displayName}</div>
    : <Button onClick={signInWithGoogle} variant="outline-primary"><BoxArrowInRight className="me-2" /> Ingresar con Google</Button>;
}
